import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

const DashboardAnnouncementModal = ({ show, onClose, classes }) => {
    if (!show) return null;

    const handleCtaClick = () => {
        const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL || 'https://app.vizualist.com/';
        window.location.href = dashboardUrl;
    };

    return (
        <Dialog
            open={show}
            onClose={onClose}
            maxWidth={false}
            PaperProps={{
                className: classes.dialogPaper,
            }}
        >
            <div className={classes.modal}>
                <div className={classes.header}>
                    <h2 className={classes.title}>Welcome to the Future</h2>
                    <p className={classes.subtitle}>
                        Your dashboard just got a major upgrade
                    </p>
                    <IconButton
                        className={classes.closeButton}
                        onClick={onClose}
                        aria-label="Close"
                    >
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M11 1L1 11M1 1L11 11"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </IconButton>
                </div>
                <div className={classes.body}>
                    <p className={classes.text}>
                        We've completely reimagined your dashboard experience
                        with new redesign, unified web components in an
                        intuitive single starting point for all our tools.
                        Discover enhanced widget creation, filtering,
                        analytics, bulk actions and stay tuned for other
                        upcoming features we developed to help you work
                        smarter.
                    </p>
                    <Button
                        variant="contained"
                        className={classes.ctaButton}
                        onClick={handleCtaClick}
                    >
                        Explore our new dashboard →
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

DashboardAnnouncementModal.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    classes: PropTypes.object,
};

const styles = {
    dialogPaper: {
        overflow: 'visible',
        borderRadius: 12,
        boxShadow: '0 10px 35px rgba(0,0,0,0.2)',
        outline: 'none',
    },
    modal: {
        width: 500,
        background: 'white',
        borderRadius: 12,
        overflow: 'hidden',
        outline: 'none',
    },
    header: {
        background: 'linear-gradient(135deg, #00A99D 0%, #008C82 100%)',
        padding: '32px 32px 24px 32px',
        position: 'relative',
        color: 'white',
    },
    title: {
        margin: 0,
        fontSize: 28,
        fontWeight: 600,
        lineHeight: 1.3,
        marginBottom: 8,
    },
    subtitle: {
        margin: 0,
        fontSize: 16,
        fontWeight: 400,
        opacity: 0.95,
        lineHeight: 1.4,
    },
    closeButton: {
        position: 'absolute',
        top: 16,
        right: 16,
        padding: 6,
        width: 28,
        height: 28,
        background: 'transparent',
        border: '1.5px solid rgba(255, 255, 255, 0.5)',
        borderRadius: 6,
        outline: 'none',
        '&:hover': {
            background: 'rgba(255, 255, 255, 0.15)',
            border: '1.5px solid rgba(255, 255, 255, 0.8)',
        },
    },
    body: {
        padding: '32px 32px 36px 32px',
        background: 'white',
    },
    text: {
        margin: 0,
        fontSize: 15,
        lineHeight: 1.8,
        color: '#5a6c7d',
        marginBottom: 24,
    },
    ctaButton: {
        width: '100%',
        background: 'linear-gradient(135deg, #00A99D 0%, #008C82 100%)',
        color: 'white',
        textTransform: 'none',
        fontSize: 16,
        fontWeight: 600,
        padding: '14px 24px',
        borderRadius: 8,
        boxShadow: '0 4px 12px rgba(0, 169, 157, 0.3)',
        outline: 'none',
        '&:hover': {
            background: 'linear-gradient(135deg, #008C82 0%, #007770 100%)',
            boxShadow: '0 6px 16px rgba(0, 169, 157, 0.4)',
        },
    },
};

export default injectSheet(styles)(DashboardAnnouncementModal);



// WEBPACK FOOTER //
// ./src/components/modals/DashboardAnnouncementModal.js